/** Coordinates in viewport space; reserve room for mobile navigation. */
export const constrainFloatingPosition = (
  position: { x: number; y: number },
  size: { width: number; height: number },
  viewport: { width: number; height: number; bottomGap: number },
  snap = false
) => {
  const maxX = Math.max(8, viewport.width - size.width - 8);
  const maxY = Math.max(8, viewport.height - viewport.bottomGap - size.height - 8);
  let x = Math.max(8, Math.min(position.x, maxX));
  if (snap) x = x + size.width / 2 < viewport.width / 2 ? 8 : maxX;
  return { x, y: Math.max(8, Math.min(position.y, maxY)) };
};
